// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Background */
/* body {
  background: linear-gradient(135deg, #667eea, #764ba2);
  min-height: 100vh;
}  */

.map-container {
  width: 100%;
  max-width: 1200px;
  margin: 30px auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.map-container iframe {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}


/* Form container */
.contact-form {
  max-width: 500px;
  margin-left: 60px auto;
  padding: 30px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 15px;
  box-shadow: 0 10px 30px rgb(12, 12, 12);
  animation: fadeIn 0.6s ease-in-out;
}

/* Heading */
.contact-form h2 {
  text-align: center;
  color: #0d0c0c;
  margin-bottom: 10px;
}

.contact-form p {
  text-align: center;
  color: #0b0a0afe;
  margin-bottom: 25px;
}

/* Form group */
.form-group {
  margin-bottom: 20px;
}

/* Labels */
label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: #444;
}

/* Inputs */
input,
textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #eee;
  border-radius: 10px;
  font-size: 14px;
  transition: 0.3s;
}

/* Focus effect */
input:focus,
textarea:focus {
  border-color: #667eea;
  box-shadow: 0 0 8px rgba(102,126,234,0.4);
  outline: none;
}

/* Textarea */
textarea {
  min-height: 120px;
  resize: none;
}

/* Button */
button {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #e85492, #ff758c);
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* Hover effect */
button:hover {
  background: linear-gradient(135deg, #ff758c, #e85492);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(232, 84, 146, 0.4);
}

button:active {
  transform: scale(0.98);
}

button:focus {
  outline: none;
  box-shadow: 0 0 10px rgba(232, 84, 146, 0.6);
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 480px) {
  .contact-form {
    margin: 20px;
    padding: 20px;
  }
}


/*    responsive   web  */
@media (max-width: 768px) {

  /* Stack flex items vertically, reduce padding/margins, smaller fonts */
  .container {
    flex-direction: column;
    padding: 16px;
  }

  h1 {
    font-size: 1.5rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 480px) {

  /* Further reductions for phones */
  .nav-bar {
    font-size: 20px;
    padding: 4px 8px;
  }

  .intro-box {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Contact.css"],"names":[],"mappings":"AAAA,eAAe;AACf;;;IAGI;;AAEJ;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,0CAA0C;AAC5C;;;AAGA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,WAAW;AACX;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,qBAAqB;EACrB,yCAAyC;EACzC,aAAa;AACf;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;;AAGA,yBAAyB;AACzB;;EAEE,uEAAuE;EACvE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;EAEE,kCAAkC;EAClC;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Background */\n/* body {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  min-height: 100vh;\n}  */\n\n.map-container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 30px auto;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n.map-container iframe {\n  width: 100%;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n}\n\n\n/* Form container */\n.contact-form {\n  max-width: 500px;\n  margin-left: 60px auto;\n  padding: 30px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgb(12, 12, 12);\n  animation: fadeIn 0.6s ease-in-out;\n}\n\n/* Heading */\n.contact-form h2 {\n  text-align: center;\n  color: #0d0c0c;\n  margin-bottom: 10px;\n}\n\n.contact-form p {\n  text-align: center;\n  color: #0b0a0afe;\n  margin-bottom: 25px;\n}\n\n/* Form group */\n.form-group {\n  margin-bottom: 20px;\n}\n\n/* Labels */\nlabel {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n  color: #444;\n}\n\n/* Inputs */\ninput,\ntextarea {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #eee;\n  border-radius: 10px;\n  font-size: 14px;\n  transition: 0.3s;\n}\n\n/* Focus effect */\ninput:focus,\ntextarea:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 8px rgba(102,126,234,0.4);\n  outline: none;\n}\n\n/* Textarea */\ntextarea {\n  min-height: 120px;\n  resize: none;\n}\n\n/* Button */\nbutton {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #e85492, #ff758c);\n  color: white;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n/* Hover effect */\nbutton:hover {\n  background: linear-gradient(135deg, #ff758c, #e85492);\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(232, 84, 146, 0.4);\n}\n\nbutton:active {\n  transform: scale(0.98);\n}\n\nbutton:focus {\n  outline: none;\n  box-shadow: 0 0 10px rgba(232, 84, 146, 0.6);\n}\n\n/* Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .contact-form {\n    margin: 20px;\n    padding: 20px;\n  }\n}\n\n\n/*    responsive   web  */\n@media (max-width: 768px) {\n\n  /* Stack flex items vertically, reduce padding/margins, smaller fonts */\n  .container {\n    flex-direction: column;\n    padding: 16px;\n  }\n\n  h1 {\n    font-size: 1.5rem;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* Further reductions for phones */\n  .nav-bar {\n    font-size: 20px;\n    padding: 4px 8px;\n  }\n\n  .intro-box {\n    padding: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
